export const featuredProducts = [
  {
    id: 1,
    name: 'Robe élégante à motifs floraux',
    price: 45.99,
    image: '/enfant-hero.jpg',
    category: 'Shopping',
    link: 'https://fr.aliexpress.com/item/1005004567890123.html',
  },
  {
    id: 2,
    name: 'Sac à main cuir premium',
    price: 89.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20leather%20handbag%20on%20white%20background%2C%20luxury%20fashion%20accessory%2C%20professional%20product%20photography%2C%20soft%20lighting%2C%20minimalist%20clean%20white%20backdrop&width=400&height=500&seq=prod2&orientation=portrait',
    category: 'Shopping',
    link: 'https://fr.aliexpress.com/item/1005005678901234.html',
  },
  {
    id: 3,
    name: 'Montre connectée sport',
    price: 129.99,
    image: 'https://readdy.ai/api/search-image?query=modern%20sport%20smartwatch%20on%20white%20background%2C%20technology%20product%20photography%2C%20professional%20shot%2C%20soft%20lighting%2C%20minimalist%20clean%20white%20backdrop&width=400&height=500&seq=prod3&orientation=portrait',
    category: 'Tech',
    link: 'https://fr.aliexpress.com/item/1005006789012345.html',
  },
  {
    id: 4,
    name: 'Écouteurs sans fil premium',
    price: 79.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20wireless%20earbuds%20on%20white%20background%2C%20technology%20product%20photography%2C%20professional%20shot%2C%20soft%20lighting%2C%20minimalist%20clean%20white%20backdrop&width=400&height=500&seq=prod4&orientation=portrait',
    category: 'Tech',
    link: 'https://fr.aliexpress.com/item/1005007890123456.html',
  },
  {
    id: 5,
    name: 'Set de soins visage bio',
    price: 34.99,
    image: 'https://readdy.ai/api/search-image?query=organic%20facial%20care%20set%20on%20white%20background%2C%20beauty%20product%20photography%2C%20professional%20shot%2C%20soft%20lighting%2C%20minimalist%20clean%20white%20backdrop&width=400&height=500&seq=prod5&orientation=portrait',
    category: 'Bien-être',
    link: 'https://fr.aliexpress.com/item/1005008901234567.html',
  },
  {
    id: 6,
    name: 'Tapis de yoga premium',
    price: 49.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20yoga%20mat%20rolled%20on%20white%20background%2C%20fitness%20product%20photography%2C%20professional%20shot%2C%20soft%20lighting%2C%20minimalist%20clean%20white%20backdrop&width=400&height=500&seq=prod6&orientation=portrait',
    category: 'Bien-être',
    link: 'https://fr.aliexpress.com/item/1005009012345678.html',
  },
  {
    id: 7,
    name: 'Appareil photo instantané',
    price: 99.99,
    image: 'https://readdy.ai/api/search-image?query=instant%20camera%20on%20white%20background%2C%20technology%20product%20photography%2C%20professional%20shot%2C%20soft%20lighting%2C%20minimalist%20clean%20white%20backdrop&width=400&height=500&seq=prod7&orientation=portrait',
    category: 'Loisirs',
    link: 'https://fr.aliexpress.com/item/1005010123456789.html',
  },
  {
    id: 8,
    name: 'Kit de peinture artistique',
    price: 54.99,
    image: 'https://readdy.ai/api/search-image?query=artistic%20painting%20kit%20on%20white%20background%2C%20hobby%20product%20photography%2C%20professional%20shot%2C%20soft%20lighting%2C%20minimalist%20clean%20white%20backdrop&width=400&height=500&seq=prod8&orientation=portrait',
    category: 'Loisirs',
    link: 'https://fr.aliexpress.com/item/1005011234567890.html',
  },
];

export const categories = [
  {
    id: 1,
    name: 'Shopping',
    subtitle: 'Mode & Accessoires',
    icon: 'ri-shopping-bag-3-line',
    gradient: 'from-pink-400 to-pink-500',
    bgColor: 'bg-pink-50',
    link: '/shopping',
  },
  {
    id: 2,
    name: 'Bien-être',
    subtitle: 'Beauté & Santé',
    icon: 'ri-heart-pulse-line',
    gradient: 'from-purple-400 to-purple-500',
    bgColor: 'bg-purple-50',
    link: '/category/bien-etre',
  },
  {
    id: 3,
    name: 'Tech',
    subtitle: 'Gadgets & Électronique',
    icon: 'ri-smartphone-line',
    gradient: 'from-cyan-400 to-cyan-500',
    bgColor: 'bg-cyan-50',
    link: '/category/tech',
  },
  {
    id: 4,
    name: 'Loisirs',
    subtitle: 'Jeux & Détente',
    icon: 'ri-gamepad-line',
    gradient: 'from-orange-400 to-orange-500',
    bgColor: 'bg-orange-50',
    link: '/category/loisirs',
  },
];

export const rgpdItems = [
  { icon: 'ri-spam-2-line', label: 'Zéro spam' },
  { icon: 'ri-shield-check-line', label: 'RGPD' },
  { icon: 'ri-mail-unread-line', label: 'Désinscription facile' },
];
